<app-pymes-seleccion [medicalOptions]="medicalOptions" [coverageOptions]="coverageOptions" [ageOptions]="ageOptions"
  [form]="form">
</app-pymes-seleccion>


<app-pymes-medico-concertado [form]="form" (setProtocol)="setProtocol($event)"></app-pymes-medico-concertado>

<section class=" mt-4">
  <div class="float-left">
    <button ca-button (click)="volverADatos()">
      {{ 'MAIN.BOTON_VOLVER' | translate }}
    </button>
  </div>
  <!-- <div class="float-right">
    <button ca-button class="ca-btn-icon__container ml-2" type="button" (click)="guardarProyecto()">
      {{'MENU.PRIVADO.GUARDAR' | translate}}
    </button>
  </div> -->
</section>
<!-- <button ca-button (click)="irALiferay()">Ir a Liferay</button> -->